import { useAppStore } from '@store'
import { ChangeEvent } from 'react'
type Props = {
  handleChange?: (e: ChangeEvent<HTMLInputElement>) => void
}

export default function GroupWrapper({ handleChange }: Props) {
  const t = useAppStore.use.t()
  return (
    <div className='mb-2 flex content-end justify-center'>
      <div className='mt-1 rounded-lg bg-C/Color10 p-1.5 shadow-md '>
        <section className='mt-auto flex items-center justify-center'>
          <input
            className='placeholder-left m-3 ml-2 h-7 w-64 border border-solid border-C/Color4 pl-2 text-sm text-C/Color4 placeholder-C/Color4 desktop:text-sm'
            type='text'
            placeholder={'Buscar...'}
            onChange={handleChange}
          />{' '}
        </section>
      </div>
      <div className='absolute w-[1980px] border-t-2 border-C/Color3 '></div>
    </div>
  )
}
